import {
  PATIENT_CATEGORIES, categoryText, type PatientCategory,
} from '../api'

/**
 * Diabetic and Non-Diabetic are two separate options. Each is its own button
 * and its own stored value; there is no combined choice and no default, so the
 * desk has to pick one on purpose.
 */
export function CategoryPicker({ id, value, onChange, disabled }: {
  id: string
  value: PatientCategory | ''
  onChange: (next: PatientCategory) => void
  disabled?: boolean
}) {
  return (
    <div className="chips" role="radiogroup" aria-labelledby={`${id}-label`} id={id}>
      {PATIENT_CATEGORIES.map((c) => (
        <button
          key={c}
          type="button"
          role="radio"
          aria-checked={value === c}
          className={`chip${value === c ? ' is-on' : ''}`}
          disabled={disabled}
          onClick={() => onChange(c)}
        >
          {categoryText(c)}
        </button>
      ))}
    </div>
  )
}

/** The category as a pill, the same everywhere a patient is shown. */
export function CategoryPill({ category }: { category: PatientCategory | null | undefined }) {
  const tone = category === 'diabetes' ? 'warn' : category === 'non_diabetic' ? 'on' : 'off'
  return <span className={`pill ${tone}`}>{categoryText(category)}</span>
}
